/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_TitleInputs */

const vi_shop_tier_title = /** @type {(inputs: Shop_Tier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng thành viên`)
};

/**

* @param {Shop_Tier_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_title = /** @type {((inputs?: Shop_Tier_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_title(inputs)
});